// Hooks/IAprofileHooks/useAddIaProfile.js

import { useState } from 'react';
import axios from 'axios';

const useAddIaProfile = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const addIaProfile = async (formData) => {
    setLoading(true);
    setSuccess(false);
    setError('');
  
    try {
      const response = await axios.post('https://niaserver-05287f289508.herokuapp.com/iaProfile/insert', formData);
      console.log('API Response:', response.data);
  
      if (response.data.success) {
        setSuccess(true);
        return { success: true }; // ✅ RETURN success here
      } else {
        setError('Failed to add the data. Please try again.');
        return { success: false }; // ✅ RETURN failure too
      }
    } catch (err) {
      console.error('Error submitting data:', err);
      setError('Something went wrong. Please try again later.');
      return { success: false }; // ✅ Always return a result
    } finally {
      setLoading(false);
    }
  };
  

  return {
    loading,
    success,
    error,
    addIaProfile,
  };
};

export default useAddIaProfile;
